import { useI18n } from "@/api/i18n";
import {
  describeRetryWait,
  type ProfileSkillWriteErrorKind,
} from "./profile-skill-write-error";

export const useProfileSkillWriteErrorMessage = () => {
  const { t } = useI18n();

  const creationQuotaMessage = (retryAfterSeconds?: number): string => {
    if (!retryAfterSeconds) return t("errors.profile_skills.creation_quota");
    const wait = describeRetryWait(retryAfterSeconds);
    switch (wait.unit) {
      case "tomorrow":
        return t("errors.profile_skills.creation_quota");
      case "hours":
        return wait.count === 1
          ? t("errors.profile_skills.creation_quota_hours_one")
          : t("errors.profile_skills.creation_quota_hours", {
              count: wait.count,
            });
      case "minutes":
        return wait.count === 1
          ? t("errors.profile_skills.creation_quota_minutes_one")
          : t("errors.profile_skills.creation_quota_minutes", {
              count: wait.count,
            });
    }
  };

  return (error: ProfileSkillWriteErrorKind): string => {
    switch (error.kind) {
      case "validation":
        return (error.message ||
          t("errors.profile_skills.validation")) as string;
      case "generic":
        return (error.message || t("errors.profile_skills.generic")) as string;
      case "rate_limited":
        return t("errors.profile_skills.rate_limited") as string;
      case "creation_quota":
        return creationQuotaMessage(error.retryAfterSeconds);
      case "claim_conflict":
        return t("errors.profile_skills.claim_conflict") as string;
      case "version_conflict":
        return t("errors.profile_skills.version_conflict") as string;
    }
  };
};
